// extracted by mini-css-extract-plugin
module.exports = {"Container":"Loader_Container__ZdLks","RouterLoaderAnimation":"Loader_RouterLoaderAnimation__1svdv","Spinner":"Loader_Spinner__3OA-t","SpinnerEl":"Loader_SpinnerEl__2x8dV"};